import React, {useState} from "react";
import {FormTab, Show, TextInput, TabbedForm, TopToolbar, NumberInput, EditButton, usePermissions} from 'react-admin';
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    adjudicacion_criterio: {display: 'inline-block', width: 200, marginLeft: 8},
    adjudicacion_criterio_d: {display: 'inline-block', width: 800, marginLeft: 8},
}));

const AdjudicacionCriterioShow = props => {
    const classes = useStyles();
    const { permissions } = usePermissions();
    var w_role_auxiliar_editar = ''
    var w_permissions_admuno_auxiliar_editar = permissions
    if(w_permissions_admuno_auxiliar_editar==null){}else{
        var wa_role_auxiliar_editar = w_permissions_admuno_auxiliar_editar.indexOf('ROLE_AUXILIAR_EDITAR')
        if(wa_role_auxiliar_editar===-1){}else{
            w_role_auxiliar_editar = 'ROLE_AUXILIAR_EDITAR'
        }
    }
    const [AdjudicacionCriterio, setAdjudicacionCriterio] = useState('');
    const [PersonaTipo, setPersonaTipo] = useState('');
    // const [AdjudicacionCriterioSocioAdjudicacionCriterioCasado, setAdjudicacionCriterioSocioAdjudicacionCriterioCasado] = useState('');

    const establecerAdjudicacionCriterio = value => {
        if (value == null || value === '') return '';
        setAdjudicacionCriterio(value.trim());
        return value;
    };

    const establecerFecha = value => {
        if (value == null || value === '') return '';
        return value;
    };

    // Obtengo tipo de persona para cargar solapa correspondiente
    const establecerPersonaTipo = value => {
        if (value == null || value === '') return '';
        setPersonaTipo(value.trim());
        return value;
    };


    const cuitCuilFormat = value => {
        if (value == null || value === '') return '';

        //normalize string and remove all unnecessary characters
        var valueCuit = value.replace(/[^\d]/g, "");

        //check if number length equals to 11
        if (valueCuit.length == 11) {
            return value.replace(/(\d{2})(\d{8})(\d{1})/, "$1-$2-$3");
        }

        return value
    };

    // const establecerAdjudicacionCriterioSocioAdjudicacionCriterioCasado = value => {
    //     if (value == null || value === '') return '';
    //     setAdjudicacionCriterioSocioAdjudicacionCriterioCasado(value.trim());
    //     return value;
    // };

    const PostEditActions = ({basePath, data, resource}) => (
        <TopToolbar>
            {w_role_auxiliar_editar === 'ROLE_AUXILIAR_EDITAR' &&
                <EditButton basePath={basePath} record={data}/>
            }
        </TopToolbar>
    );

    const PostTitle = ({record}) => {
        return <span>Adjudicacion Criterio: {record ? `${record.adjudicacion_criterio}` : ''}</span>;
    };

    return (
        <Show title={<PostTitle/>} actions={<PostEditActions/>} {...props}>
            <TabbedForm toolbar={false}>
                <FormTab label="DATOS ADJUDICACION CRITERIO">
                    <TextInput
                        label="Código Adjudicacion Criterio"
                        source="adjudicacion_criterio"
                        formClassName={classes.adjudicacion_criterio}
                        placeholder="Ingrese Código Adjudicacion Criterio"
                        helperText="Código Adjudicacion Criterio"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{readOnly: true}}
                    />

                    <br/>

                    <TextInput
                        label="Descripción Adjudicacion Criterio"
                        source="adjudicacion_criterio_d"
                        formClassName={classes.adjudicacion_criterio_d}
                        placeholder="Ingrese Descripción Adjudicacion Criterio"
                        helperText="Descripción Adjudicacion Criterio"
                        margin="normal"
                        fullWidth={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{readOnly: true}}
                    />

                </FormTab>
            </TabbedForm>
        </Show>
    )
};
export default AdjudicacionCriterioShow;


